import { memo } from "react"

const DownloadIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.53329 12.8331C8.81473 12.7947 9.05031 12.6006 9.14183 12.3317C10.1153 9.47182 12.8158 7.41602 15.9998 7.41602C20.0043 7.41602 23.2498 10.6616 23.2498 14.666C23.2498 15.0802 23.5856 15.416 23.9998 15.416C26.531 15.416 28.5832 17.4682 28.5832 19.9993C28.5832 22.5305 26.531 24.5827 23.9998 24.5827H9.33317C6.06605 24.5827 3.4165 21.9331 3.4165 18.666C3.4165 15.6782 5.64233 13.2278 8.53329 12.8331Z"
        stroke="#29369F"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.889 17.7773L15.9997 20.6667L13.1104 17.7773"
        stroke="#29369F"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.9997 14V20.6667"
        stroke="#29369F"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export default memo(DownloadIcon)
